document.addEventListener('DOMContentLoaded', function () {
  new ScrollHint('.js-scrollable', {
    suggestiveShadow: true,
    i18n: {
      scrollable: 'スクロールできます',
    },
  });
});
